import { tv } from 'tailwind-variants';

export const container = tv({
  base: 'flex h-8 flex-1 justify-end',
});

export const menu = tv({
  base: 'h-full md:relative',
});

export const menuButton = tv({
  base: [
    'relative flex h-full items-center justify-between gap-2 whitespace-nowrap rounded-none border-l border-transparent uppercase tracking-wide',
    'focus-visible:outline focus-visible:outline-1 focus-visible:-outline-offset-4 focus-visible:outline-black',
    'after:pointer-events-none after:absolute after:-bottom-px after:left-0 after:right-0 after:block after:h-px ',
  ],
});

export const menuButtonOpen = tv({
  base: 'ui-open:border-gray-150 ui-open:after:bg-white',
});

export const label = tv({
  base: 'block truncate hover:underline',
});

export const icon = tv({
  base: 'h-4 w-4 flex-shrink-0 text-base mb-0',
});

export const iconOpen = tv({
  base: 'ui-open:rotate-180',
});

export const itemsList = tv({
  base: 'hidden md:block border-gray-150 absolute left-4 right-4 md:right-0 z-10 border-b border-x bg-white py-0 text-sm max-md:mt-px md:left-auto md:top-full md:mt-px md:w-full md:min-w-[110px] md:border-x whitespace-nowrap focus:outline-none',
});

export const item = tv({
  base: 'ui-active:bg-gray-100 flex w-full px-3 py-2.5 text-left',
});
